import { withStyles } from "@material-ui/core";
import styles from "./styles";
import PopupFieldRenderer from "./common/PopupFieldRenderer";
import { getMinutesInHourAndMinutesStr } from "../../util";

const getDelayStopLabelByType = (task) => {
  if (task?.data?.isRouteLevelDelayStop && task.data.routeLevelDelayStopName) return task.data.routeLevelDelayStopName.toUpperCase();
  return '';
};

const getDelayStopValue = (task) => {
  const delayInterval = task?.data?.delayInterval;
  if (delayInterval) {
    const delayIntervalInMinutes = Number(delayInterval);
    if (Number.isFinite(delayIntervalInMinutes)) {
      return String(getMinutesInHourAndMinutesStr(delayIntervalInMinutes));
    }
    return String(delayInterval);
  }
  return `${task.arrivalTime} - ${task.departureTime}`;
};

const DelayStopPopup = ({ task, classes }) => {
  return (
    <div className={classes.popupContainer}>
      <PopupFieldRenderer
        label={getDelayStopLabelByType(task)}
        value={getDelayStopValue(task)}
        valueClassName={classes.headerRowValue}
      />
    </div>
  );
};

export default withStyles(styles)(DelayStopPopup);
